/* WPO inquiry attribution v1. Stores source context only; sends no ad-platform events. */
(function () {
  'use strict';
  var tracker = window.WolfPackTracker;
  if (!tracker || typeof tracker.attach !== 'function' || tracker.attributionVersion) return;
  var originalAttach = tracker.attach;
  var storageKey = 'wpo_ad_attribution_v1';
  var ttl = 30 * 24 * 60 * 60 * 1000;
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'campaign_id', 'ad_group_id', 'ad_id', 'oppref'];
  var state = null;
  var captured = false;

  function allowed() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.marketingAllowed() === true);
    } catch (e) { return false; }
  }
  function clear() {
    state = null;
    captured = false;
    try { window.localStorage.removeItem(storageKey); } catch (e) {}
  }
  function fresh(touch) {
    return touch && typeof touch.at === 'number' && touch.at <= Date.now() && Date.now() - touch.at < ttl;
  }
  function readState() {
    try {
      var value = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      if (value && value.version === 1 && fresh(value.last)) {
        return {version: 1, first: fresh(value.first) ? value.first : value.last, last: value.last};
      }
    } catch (e) {}
    return null;
  }
  function capture() {
    if (!allowed()) { clear(); return; }
    if (!state) state = readState();
    if (state && !fresh(state.last)) state = null;
    if (captured) return;
    captured = true;
    var params = new URLSearchParams(window.location.search);
    var touch = {};
    var tagged = false;
    keys.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        touch[key] = value.slice(0, key === 'oppref' ? 4096 : 256);
        tagged = true;
      }
    });
    if (!tagged) return;
    touch.at = Date.now();
    // Exclude unrelated query strings, which can contain private form values.
    touch.landing_page = window.location.origin + window.location.pathname;
    state = {version: 1, first: state && fresh(state.first) ? state.first : touch, last: touch};
    try { window.localStorage.setItem(storageKey, JSON.stringify(state)); } catch (e) {}
  }
  function safe(value) {
    return String(value || '').replace(/[\r\n\t<>"'&]/g, ' ').trim();
  }
  function describe(label, touch) {
    var values = [label + ' tagged visit: ' + new Date(touch.at).toISOString()];
    keys.forEach(function (key) { if (touch[key]) values.push(key + ': ' + safe(touch[key])); });
    values.push('Landing page: ' + safe(touch.landing_page));
    return values.join('\n');
  }
  function submissionId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'wpo-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  tracker.attach = function (payload) {
    payload = originalAttach.call(tracker, payload) || payload || {};
    // Keep the original source separately and use the already-mapped source
    // string for backward-compatible delivery into Make and Shopmonkey notes.
    payload.form_source = payload.form_source || payload.source || 'website';
    payload.submission_id = payload.submission_id || submissionId();
    try {
      capture();
      var summary = ['AD ATTRIBUTION', 'Submission ID: ' + safe(payload.submission_id)];
      if (allowed() && state && fresh(state.last)) {
        payload.attribution = JSON.parse(JSON.stringify(state));
        summary.push(describe('First', state.first));
        if (JSON.stringify(state.first) !== JSON.stringify(state.last)) summary.push(describe('Latest', state.last));
        summary.push('Basis: URL tags retained up to 30 days; not an Ads Manager conversion.');
      } else {
        delete payload.attribution;
        summary.push(allowed() ? 'Source detail: no retained campaign tags.' : 'Source detail: attribution unavailable under current privacy permissions.');
      }
      payload.source = payload.form_source + '\n' + summary.join('\n');
    } catch (e) {
      payload.source = payload.form_source;
      delete payload.attribution;
    }
    return payload;
  };
  tracker.attributionVersion = 1;
  document.addEventListener('visitorConsentCollected', capture);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
      if (!error) capture();
    });
  } else { capture(); }
})();
